import { createEndpoint } from '@/shared/models/api';
import { Informative } from '@/app/api/morgan-thermal';
import { ProjectInformation } from '@/app/api/morgan-thermal/project';

export type CopyProjectResponse = Informative & { id: ProjectInformation['id'] };

export const copyProject = createEndpoint<CopyProjectResponse>(({ fetch }) => {
  return (id: ProjectInformation['id']) => fetch(`/Project/Copy/${id}`, { method: 'POST' });
});